const LOCAL_STORAGE_ACTIVITY_KEY = 'babylon-auth-last-activity-time'

export const setLastActivityTime = (date: Date): void =>
  localStorage.setItem(LOCAL_STORAGE_ACTIVITY_KEY, date.toISOString())

export const getLastActivityTime = (): Date | null => {
  const val = localStorage.getItem(LOCAL_STORAGE_ACTIVITY_KEY)
  return typeof val === 'string' ? new Date(val) : null
}
